// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import RenovationFeeInput from '../renovation-fees';

const RenovationFeesInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <RenovationFeeInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default RenovationFeesInputWithAnalytics;
